import type { HTMLAttributes, InputHTMLAttributes } from 'react'
import type { AutocompleteRenderInputParams, OutlinedInputProps } from '@mui/material'
import { hasOwnProperty } from '../../../helpers'

type SlotProps = {
  htmlInput?: AutocompleteRenderInputParams['inputProps']
  input?: AutocompleteRenderInputParams['InputProps']
  inputLabel?: AutocompleteRenderInputParams['InputLabelProps']
}

export type Mui7Params = AutocompleteRenderInputParams & {
  InputProps?: Partial<OutlinedInputProps>
  inputProps?: InputHTMLAttributes<HTMLInputElement>
  inputLabel?: HTMLAttributes<HTMLLabelElement>
}

export type Mui9Params = Omit<AutocompleteRenderInputParams, 'InputLabelProps' | 'InputProps' | 'inputProps'> & {
  slotProps: SlotProps
}

export type CompatibleRenderInputParams = Mui7Params | Mui9Params

const isMui9 = (params: CompatibleRenderInputParams): params is Mui9Params => hasOwnProperty(params, 'slotProps')

/**
 * Handle both MUI7 and MUI9 structures
 * MUI9 wraps everything in slotProps
 * MUI7 has InputProps, inputProps directly
 * @note if this is applicable for other components, move this helper accordingly
 * @todo remove when we move to mui9
 */
export const prepareForMui9PropPropagation = (params: CompatibleRenderInputParams): SlotProps => {
  if (isMui9(params)) {
    return params.slotProps
  }
  return {
    htmlInput: params.inputProps,
    input: params.InputProps,
    inputLabel: params.inputLabel,
  }
}
